import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { shouldEnableErrorReporting } from './environment.js';

// Type assertion to work around TypeScript type issues
const BugsnagClient = Bugsnag as any;

// Get environment variables
const apiKey = import.meta.env.VITE_BUGSNAG_API_KEY;
const environment = import.meta.env.VITE_ENVIRONMENT || 'development';
const appVersion = import.meta.env.VITE_APP_VERSION || '1.0.0';

// Track if Bugsnag has been initialized
let isBugsnagInitialized = false;

// Initialize Bugsnag only when error reporting should be enabled
if (apiKey && apiKey.trim() !== '' && shouldEnableErrorReporting()) {
  try {
    // Start Bugsnag error reporting
    BugsnagClient.start({
      apiKey,
      plugins: [new (BugsnagPluginReact as any)()],
      releaseStage: environment,
      enabledReleaseStages: ['staging', 'production'],
      appVersion: appVersion,
      // Source map configuration for better error tracking
      sendCode: true,
      // Additional configuration
      autoDetectErrors: true,
      autoTrackSessions: true,
      collectUserIp: false,
      maxBreadcrumbs: 50,
      enabledBreadcrumbTypes: ['navigation', 'request', 'process', 'log', 'user', 'state', 'error']
    });

    // Start Bugsnag performance monitoring
    BugsnagPerformance.start({
      apiKey,
      releaseStage: environment,
      enabledReleaseStages: ['staging', 'production']
    });

    isBugsnagInitialized = true;
  } catch (error) {
    console.warn('Failed to initialize Bugsnag:', error);
    isBugsnagInitialized = false;
  }
}

export default BugsnagClient;
export { isBugsnagInitialized };
